intra_module.controller('RedirectProfElearningCtrl', function(identity, $location, $window, intraprof_web_url) {
	identity.$promise.then(function(me) {
		if ((-1 === me.groups.indexOf('adm')) && (-1 === me.groups.indexOf('prof'))) {
			$location.path('/403');
			return;
		}
		let url  = `${intraprof_web_url}`;
		if ($location.search().id != null) {
			url += '/modules/' + $location.search().id;
		}
		$window.location.href = url;
	});
});
